import React, { type FC } from "react";
import { Link } from "react-router-dom";
import { BriefcaseIcon, ColorModeIcon, InfoIcon, SettingIcon, SignOutIcon } from "@omega/icons";
import { AppPaths } from "@app/router/paths";
import { redirectToAuth } from "@app/router/redirectToAuth";
import useAuthStore from "@app/store/useAuthStore";
import "./Menu.scss";

/**
 * Главное меню приложения (кнопка «Меню» в NavBar).
 */
const Menu: FC = () => {
    const logout = useAuthStore((state) => state.logout);

    const handleLogout = (): void => {
        logout();
        redirectToAuth();
    };

    return (
        <div className="app_menu">
            <header className="app_menu__header">
                <h1 className="app_menu__title">Меню</h1>
            </header>

            <main className="app_menu__body">
                <Link to={AppPaths.TASKS} className="app_menu__item">
                    <span className="app_menu__item-icon">
                        <BriefcaseIcon size={24} />
                    </span>
                    <span className="app_menu__item-label">Задачи</span>
                </Link>
            </main>

            <footer className="app_menu__footer">
                <Link to={AppPaths.SETTING} className="app_menu__item">
                    <span className="app_menu__item-icon">
                        <SettingIcon size={24} />
                    </span>
                    <span className="app_menu__item-label">Настройки</span>
                </Link>
                <Link to={AppPaths.THEME} className="app_menu__item">
                    <span className="app_menu__item-icon">
                        <ColorModeIcon size={24} />
                    </span>
                    <span className="app_menu__item-label">Тема</span>
                </Link>
                <Link to={AppPaths.ABOUT_SYSTEM} className="app_menu__item">
                    <span className="app_menu__item-icon">
                        <InfoIcon size={24} />
                    </span>
                    <span className="app_menu__item-label">О системе</span>
                </Link>
                <button type="button" className="app_menu__item app_menu__item_logout" onClick={handleLogout}>
                    <span className="app_menu__item-icon">
                        <SignOutIcon size={24} />
                    </span>
                    <span className="app_menu__item-label">Выйти</span>
                </button>
            </footer>
        </div>
    );
};

export default Menu;
